import { icon } from '../services/icons.js';
import { i18n } from '../services/i18n.js';
import { dbSim } from '../services/dbSim.js';

const escapeHtml = (value = '') => String(value).replace(/[&<>'"]/g, character => ({
  '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
}[character]));

export const SettingsView = async (container) => {
  const user = JSON.parse(localStorage.getItem('h150_auth_user') || 'null');
  if (!user) {
    window.location.hash = '#/login';
    return;
  }

  const name = user.name || user.email || 'Host';
  const initial = name.trim().charAt(0).toUpperCase();
  const avatar = user.avatar
    ? `<img src="${escapeHtml(user.avatar)}" alt="" referrerpolicy="no-referrer">`
    : `<span>${escapeHtml(initial)}</span>`;
  const brand = await dbSim.getBrand().catch(() => ({ name: '', tagline: '', revision: -1, canUpdate: true }));
  const hasBrand = brand.revision >= 0;
  const canEdit = !hasBrand || brand.canUpdate;
  const lockDate = brand.nextUpdateAt ? new Date(brand.nextUpdateAt).toLocaleString(i18n.getLang() === 'vi' ? 'vi-VN' : 'en-US') : '';

  container.innerHTML = `
    <section class="settings-page container">
      <a class="settings-back" href="#/dashboard">${icon('arrowLeft')} ${i18n.t('back_to_dashboard')}</a>
      <div class="settings-heading">
        <h1>${i18n.t('account_settings')}</h1>
        <p>${i18n.t('account_settings_help')}</p>
      </div>
      <div class="account-summary">
        <div class="account-summary-avatar">${avatar}</div>
        <div>
          <strong>${escapeHtml(name)}</strong>
          <span>${escapeHtml(user.email || '')}</span>
        </div>
      </div>
      <section class="language-settings" aria-labelledby="languageSettingsTitle">
        <div class="brand-settings-heading">
          <h2 id="languageSettingsTitle">${i18n.t('language_title')}</h2>
          <p>${i18n.t('language_help')}</p>
        </div>
        <div class="language-options" role="radiogroup" aria-label="${i18n.t('language_title')}">
          <label class="language-option ${i18n.getLang() === 'vi' ? 'selected' : ''}">
            <input type="radio" name="appLanguage" value="vi" ${i18n.getLang() === 'vi' ? 'checked' : ''}>
            <span><strong>Tiếng Việt</strong><small>VI</small></span>
          </label>
          <label class="language-option ${i18n.getLang() === 'en' ? 'selected' : ''}">
            <input type="radio" name="appLanguage" value="en" ${i18n.getLang() === 'en' ? 'checked' : ''}>
            <span><strong>English</strong><small>EN</small></span>
          </label>
        </div>
      </section>
      <section class="brand-settings">
        <div class="brand-settings-heading">
          <h2>${i18n.t('brand_title')}</h2>
          <p>${i18n.t('brand_help')}</p>
        </div>
        <form id="brandForm">
          <div class="form-group">
            <label class="form-label" for="brandNameInput">${i18n.t('brand_name')}</label>
            <input id="brandNameInput" class="input-field" minlength="2" maxlength="80" value="${escapeHtml(brand.name)}" placeholder="${i18n.t('brand_name_placeholder')}" ${canEdit ? '' : 'disabled'} required>
          </div>
          <div class="form-group">
            <label class="form-label" for="brandTaglineInput">${i18n.t('brand_tagline')}</label>
            <input id="brandTaglineInput" class="input-field" maxlength="160" value="${escapeHtml(brand.tagline)}" placeholder="${i18n.t('brand_tagline_placeholder')}" ${canEdit ? '' : 'disabled'}>
          </div>
          <p class="brand-rule">${brand.revision <= 0 ? i18n.t('brand_first_lock') : i18n.t('brand_weekly_lock')}</p>
          ${!canEdit ? `<p class="brand-lock">${icon('lock')} ${i18n.t('brand_locked_until')}: <strong>${escapeHtml(lockDate)}</strong></p>` : ''}
          <button class="btn btn-primary" type="submit" ${canEdit ? '' : 'disabled'}>${i18n.t('save_brand')}</button>
        </form>
      </section>
    </section>`;

  const form = container.querySelector('#brandForm');
  container.querySelectorAll('input[name="appLanguage"]').forEach(input => {
    input.addEventListener('change', event => i18n.setLang(event.target.value));
  });
  form.addEventListener('submit', async event => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    button.disabled = true;
    try {
      await dbSim.saveBrand({
        name: form.querySelector('#brandNameInput').value,
        tagline: form.querySelector('#brandTaglineInput').value
      });
      window.showToast(i18n.t('brand_saved'));
      await SettingsView(container);
    } catch (error) {
      button.disabled = false;
      window.showToast(error.message);
    }
  });
};
